import { Select, Text, Flex, Divider, Heading, Button, SimpleGrid, Box, Spinner, List, ListItem, Img } from '@chakra-ui/core';
import React, { useCallback, useState, useEffect } from 'react';
import useBreakPointValue from '../hooks/useBreakPointValue';
import gtag, { install } from 'ga-gtag';
import Axios from 'axios';

interface Props {}

const MainPage = (props: Props) => {
  const mainTitleSize = useBreakPointValue(['5xl', '5xl', '5xl', '6xl']);
  const subTitleSize = useBreakPointValue(['22px', '2xl', '2xl', '3xl']);
  const headingSize = useBreakPointValue(['md', 'md', 'lg']);
  const spinnerSize = useBreakPointValue(['md', 'md', 'xl']);
  const [models, setModels] = useState([]);
  const [generations, setGenerations] = useState([]);
  const communicationTypes = ['WIFI', 'CELLULAR'];
  const [capacities, setCapacities] = useState([]);
  const status = ['UNOPENED', 'A', 'B', 'C'];
  const [selectedModel, setSelectedModel] = useState();
  const [selectedGeneration, setSelectedGeneration] = useState();
  const [selectedCommunication, setSelectedCommunication] = useState();
  const [selectedCapacity, setSelectedCapacity] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const [itemId, setItemId] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPrice, setIsShowPrice] = useState(false);
  const [price, setPrice] = useState(0);

  const handleChange = useCallback(
    (e: any, index: number) => {
      if (index === 0) {
        setSelectedModel(e.target.value);
        Axios.get(`https://devcrews.io/v1/api/itemType?level=2&itemTypeName=${e.target.value}`).then((data) => {
          setGenerations(data.data.itemTypeApiDtoList);
        });
      } else if (index === 1) {
        setSelectedGeneration(e.target.value);
      } else if (index === 2) {
        setSelectedCommunication(e.target.value);
        Axios.get(`https://devcrews.io/v1/api/itemType?level=3&itemTypeName=${selectedModel}&generationId=${selectedGeneration}&communicationType=${e.target.value}`).then((data) => {
          setCapacities(data.data.itemTypeApiDtoList);
        });
      } else if (index === 3) {
        setSelectedCapacity(e.target.value);
        Axios.get(
          `https://devcrews.io/v1/api/itemType?level=4&itemTypeName=${selectedModel}&generationId=${selectedGeneration}&communicationType=${selectedCommunication}&capacityId=${e.target.value}`
        ).then((data) => {
          setItemId(data.data.itemTypeApiDtoList[0].itemTypeId);
        });
      } else if (index === 4) {
        setSelectedStatus(e.target.value);
      }
    },
    [selectedModel, selectedGeneration, selectedCommunication]
  );

  const handleCheckPrice = useCallback(() => {
    setIsShowPrice(true);
    setIsLoading(true);
    gtag('event', '버튼클릭', { event_category: '메인페이지', event_label: '가격확인' });
    Axios.get(`https://devcrews.io/v1/api/market-price/${itemId}/${selectedStatus}`)
      .then((data) => {
        setIsLoading(false);
        setPrice(data.data.result);
      })
      .catch((e) => {
        setIsLoading(false);
        setPrice(0);
      });
  }, [selectedStatus, itemId]);

  const handleSubmit = useCallback(() => {
    console.log(selectedModel, selectedGeneration, selectedCommunication, selectedCapacity, selectedStatus);
    gtag('event', '버튼클릭', { event_category: '메인페이지', event_label: '알림신청' });
    alert('딱 맞는 중고 상품을 추천해드리기 위해 준비 중이에요. 조금만 기다려주세요:)');
  }, [selectedModel, selectedGeneration, selectedCommunication, selectedCapacity, selectedStatus]);

  useEffect(() => {
    if (isShowPrice && isLoading) {
      window.scrollTo(0, document.documentElement.scrollHeight);
    }
  }, [isShowPrice, isLoading]);

  useEffect(() => {
    install('UA-180911695-1');
    Axios.get('https://devcrews.io/v1/api/itemType?level=1').then((data) => {
      setModels(data.data.itemTypeApiDtoList.map((d: any) => d.itemTypeName));
    });
  }, []);

  return (
    <Flex direction='column' mt='4' mb='12' maxW={960} margin='auto' px='4' py='4' overflowX='hidden'>
      <Img src='/ipad.png' alt='' w={['300%', '100%']} maxWidth='300%' margin='auto' mt='12' mb={[-40, -20, -40]} ml={['-36px', '0']} />

      <Heading textAlign={['left', 'left', 'center']} mb={['2', '0']} px={['4', '8', '12']} pt={['4', '8', '12']} fontSize={mainTitleSize} fontWeight='800' wordBreak='keep-all'>
        아이패드 중고가격 계산기
      </Heading>
      <Heading
        textAlign={['left', 'left', 'center']}
        as='h2'
        px={['4', '8', '12']}
        pt={['4', '2', '4']}
        pb={['16', '16']}
        fontSize={subTitleSize}
        color='gray.600'
        fontWeight='600'
        lineHeight='150%'
        wordBreak='keep-all'>
        원하시는 모델을 선택해주세요.
      </Heading>
      <SimpleGrid columns={[1, 2]} p={['8', '8', '12']} gap='8' background='#fff' borderRadius='18px' boxShadow='0px 0px 16px -6px rgba(8, 16, 32, 0.6)'>
        <Box>
          <Text fontSize='md' color='gray.600' fontWeight='500'>
            모델
          </Text>
          <Select placeholder='선택해주세요' variant='filled' bg='gray.200' color='gray.900' fontWeight='600' size='lg' borderRadius='8px' mt='3' onChange={(e) => handleChange(e, 0)}>
            {models.map((model, index) => {
              return (
                <option key={index} value={model}>
                  {model}
                </option>
              );
            })}
          </Select>
        </Box>
        <Box>
          <Text fontSize='md' color='gray.600' fontWeight='500'>
            세대
          </Text>
          <Select placeholder='선택해주세요' variant='filled' bg='gray.200' color='gray.900' fontWeight='600' size='lg' borderRadius='8px' mt='3' onChange={(e) => handleChange(e, 1)}>
            {generations.map((v: any, index) => {
              return (
                <option key={index} value={v.generationId}>
                  {v.generationName}
                </option>
              );
            })}
          </Select>
        </Box>
        <Box>
          <Text fontSize='md' color='gray.600' fontWeight='500'>
            연결성
          </Text>
          <Select placeholder='선택해주세요' variant='filled' bg='gray.200' color='gray.900' fontWeight='600' size='lg' borderRadius='8px' mt='3' onChange={(e) => handleChange(e, 2)}>
            {communicationTypes.map((data, index) => {
              return (
                <option key={index} value={data}>
                  {data}
                </option>
              );
            })}
          </Select>
        </Box>
        <Box>
          <Text fontSize='md' color='gray.600' fontWeight='500'>
            용량
          </Text>
          <Select placeholder='선택해주세요' variant='filled' bg='gray.200' color='gray.900' fontWeight='600' size='lg' borderRadius='8px' mt='3' onChange={(e) => handleChange(e, 3)}>
            {capacities.map((c: any, index) => {
              return (
                <option key={index} value={c.capacityId}>
                  {c.capacityNm}
                </option>
              );
            })}
          </Select>
        </Box>
        <Box>
          <Text fontSize='md' color='gray.600' fontWeight='500'>
            상태
          </Text>
          <Text color='gray.500' fontSize='xs'>
            흡집, 생활기스 등 외관 상태에 따른 등급이에요.
          </Text>
          <Select placeholder='선택해주세요' variant='filled' bg='gray.200' color='gray.900' fontWeight='600' size='lg' borderRadius='8px' mt='3' onChange={(e) => handleChange(e, 4)}>
            {status.map((stat, index) => {
              return (
                <option key={index} value={stat}>
                  {index === 0 ? '미개봉' : `${stat}급`}
                </option>
              );
            })}
          </Select>
        </Box>
      </SimpleGrid>
      <Flex justify='center'>
        <Button
          background={'rgb(20, 80, 240)'}
          size='lg'
          color={'white'}
          width='210px'
          height='56px'
          borderRadius='8px'
          _active={{ background: 'rgb(14, 58, 168)' }}
          _hover={{ background: 'rgb(18, 72, 216)' }}
          onClick={handleCheckPrice}
          my='12'>
          중고 가격 확인하기
        </Button>
      </Flex>
      {isShowPrice && (
        <>
          <Flex px={['4', '8', '12']}>
            <Divider borderColor='gray.200' my={['6', '8']} />
          </Flex>
          <Flex direction='column' p={['4', '8', '12']}>
            <Heading as='h3' size={headingSize} textAlign='center'>
              최근 한달 평균 가격
            </Heading>
            <Text fontSize='sm' mt='3' color='gray.500' textAlign='center'>
              {selectedModel} {selectedGeneration}세대 <br /> {selectedCommunication}{' '}
              {
                (capacities.filter((c: any) => {
                  return c.capacityId === parseInt(selectedCapacity!, 10);
                })[0] as any).capacityNm
              }{' '}
              {selectedStatus === 'UNOPENED' ? '미개봉' : `${selectedStatus}급`}
            </Text>
            <Text fontSize={['5xl', '5xl', '6xl']} letterSpacing='-2px' fontWeight='bold' textAlign='center' mt={['2', '4']}>
              {isLoading ? (
                <Spinner as='span' size={spinnerSize} color='rgb(20, 80, 240)' />
              ) : price === 0 ? (
                <span>
                  아직 데이터가 없어요
                  <span role='img' aria-label='emoji'>
                    😥
                  </span>
                </span>
              ) : (
                `${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원`
              )}
            </Text>
          </Flex>
          <Flex justify='center'>
            <Button
              background='gray.200'
              size='2xl'
              color='rgb(20, 80, 240)'
              width='210px'
              height='56px'
              borderRadius='8px'
              _active={{ background: 'white' }}
              _hover={{ background: 'white' }}
              onClick={handleSubmit}>
              <span>
                <span role='img' aria-label='emoji'>
                  🔔
                </span>
                새로운 판매글 알림 받기
              </span>
            </Button>
          </Flex>
          <List spacing='1' p={['4', '8', '12']} mt='12'>
            <ListItem>
              <Flex align='center'>
                <Text ml='1' color='gray.500' fontSize='sm'>
                  <span role='img' aria-label='emoji'>
                    😃
                  </span>{' '}
                  중고나라, 번개장터에서 판매 중이거나 판매 완료된 제품의 평균가입니다.
                </Text>
              </Flex>
            </ListItem>
            <ListItem>
              <Flex align='center'>
                <Text ml='1' color='gray.500' fontSize='sm'>
                  <span role='img' aria-label='emoji'>
                    😃
                  </span>{' '}
                  전문 매입 업자를 제외한 개인 간 거래건만 포함했어요.
                </Text>
              </Flex>
            </ListItem>
          </List>
        </>
      )}
    </Flex>
  );
};

export default MainPage;
